module.exports = require('./lib/index').default;


//////////////////
// WEBPACK FOOTER
// ./~/axios-retry/index.js
// module id = 211
// module chunks = 13